import classNames from 'classnames';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { RadioButton } from 'common/components/forms';
import { FormError, Button } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateAndChargePayGate } from 'redux/cart/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

import PayGateHiddenForm from './PayGateHiddenForm';
import AddressPicker from './components/AddressPicker';
import {
  validateAddressForLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 'shipping',
      isSaveAddress: true,
      redirect: null,
      isSubmitting: false
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleSubmit = (form) => {
    const { props, state } = this;
    this.setState({ isSubmitting: true });
    const data = transformData(form, this.props);
    const successFunction = (order) => {
      props.history.push(`/checkout/receipt/${order.id}`);
    };
    const redirectFunction = (response) => {
      this.setState({ redirect: response });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    const isSaveAddress =
      form.isSameAsBillingAddress === 'billing' && state.isSaveAddress;
    props.updateAndChargePayGate(
      data.address,
      data.creditCard,
      isSaveAddress,
      successFunction,
      redirectFunction,
      errorFunction
    );
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('shipping');
  };

  handleSaveAddress = (e) => {
    this.setState({ isSaveAddress: e.target.checked });
  };

  handleSameAsBilling = (e) => {
    this.setState({ selectedOption: e.currentTarget.value });
  };

  render() {
    const { cart, handleSubmit, change, form, settings } = this.props;
    const { customerAddresses } = this.props;
    const { selectedOption, isSaveAddress, redirect, isSubmitting } =
      this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (cart.shipTo) {
      object = cart.shipTo;
    }
    if (redirect) {
      return <PayGateHiddenForm redirect={redirect} />;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <CreditCardForm />

        <p>&nbsp;</p>
        <h3>Billing address</h3>
        <div className="c7-checkout__content__radio-options-group">
          <Field
            name="isSameAsBillingAddress"
            component={RadioButton}
            label="Same as shipping address"
            onChange={this.handleSameAsBilling}
            type="radio"
            value="shipping"
          />

          <div className="c7-no-border">
            <Field
              name="isSameAsBillingAddress"
              component={RadioButton}
              label="Use a different billing address"
              onChange={this.handleSameAsBilling}
              type="radio"
              value="billing"
            />
          </div>

          <div
            className={classNames(
              selectedOption === 'shipping'
                ? 'c7-checkout__content__radio-options-group__hidden'
                : 'c7-checkout__content__radio-options-group__edit'
            )}
          >
            <AddressPicker
              customerAddresses={customerAddresses.data}
              onAddressChange={this.handleAddressChange}
            />
            <AddressForm
              object={object}
              changeFunction={change}
              settings={settings}
            />
            <div>
              <label htmlFor="saveAddress">
                <input
                  type="checkbox"
                  name="saveAddress"
                  onChange={this.handleSaveAddress}
                  value
                  checked={isSaveAddress}
                />
                Save this information
              </label>
            </div>
          </div>
        </div>

        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete Order
          </Button>
          <a
            href="#"
            aria-label="Return to shipping method"
            onClick={this.handleBack}
          >
            Return to shipping method
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let address;
  if (values.isSameAsBillingAddress === 'billing') {
    address = transformAddressData(values);
    address.customerAddressId = values.customerAddressId;
  } else {
    address = props.cart.data.shipTo;
    delete address.id;
  }

  const creditCard = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName
  };

  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  if (values.isSameAsBillingAddress === 'billing') {
    const { address } = transformData(values, props);
    address.birthDay =
      values.birthDay && convertStringToInteger(values.birthDay);
    address.birthMonth =
      values.birthMonth && convertStringToInteger(values.birthMonth);
    address.birthYear =
      values.birthYear && convertStringToInteger(values.birthYear);
    errors = Object.assign(
      errors,
      validateAddressForLoggedInCustomer(address, props.settings)
    );
  }
  if (!values.customerCreditCardId || values.customerCreditCardId === '') {
    const { creditCard } = transformData(values, props);
    errors = Object.assign(errors, validateCreditCard(creditCard));
  }
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  let selectedCreditCardId;
  if (state.cart && state.cart.data) {
    const { billTo } = state.cart.data;
    initialValues = initialFormValues(billTo);
    initialValues.isSameAsBillingAddress = 'shipping';
    const { tenders } = state.cart.data;
    if (tenders.length > 0) {
      const { creditCard } = tenders[0];
      initialValues.customerCreditCardId = creditCard.customerCreditCardId;
      selectedCreditCardId = creditCard.customerCreditCardId;
    }
  }
  return {
    cart: state.cart,
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues,
    selectedCreditCardId
  };
};

Payment = reduxForm({
  form: 'paymentLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, {
    updateAndChargePayGate,
    listCustomerAddresses
  })(Payment)
);
